import {
  DescriptiveBlockWithOptionalValues,
  DescriptiveBlockWithOptionalValuesProps,
} from "./descriptiveBlockWithOptionalValues/DescriptiveBlockWithOptionalValues";
import styles from "./DescriptiveBlockWithOptionalValuesList.module.scss";

export type DescriptiveBlockWithOptionalValuesListProps = {
  descriptiveBlocksWithOptionalValues: DescriptiveBlockWithOptionalValuesProps[];
};

export const DescriptiveBlockWithOptionalValuesList = ({
  descriptiveBlocksWithOptionalValues,
}: DescriptiveBlockWithOptionalValuesListProps) => (
  <div className={styles.container}>
    {descriptiveBlocksWithOptionalValues.map(
      (descriptiveBlockWithOptionalValues, index) => (
        <DescriptiveBlockWithOptionalValues
          {...descriptiveBlockWithOptionalValues}
          key={index}
        />
      )
    )}
  </div>
);
